import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';

export default function PortfolioHistoryLiquidationsTableControls() {
	return (
		<PortfolioHistoryTableControls
			historyType="liquidations"
			exportType="liquidations"
		/>
	);
}
